
(function () {
  "use strict";

  const STORAGE_KEY = "vw_juicyads_s2s";
  const EXPIRY_KEY = "vw_juicyads_s2s_expiry";
  const EXPIRY_DAYS = 30;

  function getClickID() {
    const params = new URLSearchParams(window.location.search);
    const incoming = params.get("juicy_s2s");

    if (incoming && /^[a-zA-Z0-9_-]{1,256}$/.test(incoming)) {
      try {
        localStorage.setItem(STORAGE_KEY, incoming);
        localStorage.setItem(
          EXPIRY_KEY,
          String(Date.now() + EXPIRY_DAYS * 86400000)
        );
      } catch (error) {
        // Browser storage may be unavailable.
      }

      return incoming;
    }

    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      const expiry = Number(localStorage.getItem(EXPIRY_KEY));

      if (stored && expiry > Date.now()) {
        return stored;
      }

      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(EXPIRY_KEY);
    } catch (error) {
      // Browser storage may be unavailable.
    }

    return null;
  }

  async function attachClickIDToCart(clickID) {
    if (!clickID) return;

    try {
      const response = await fetch(
        window.Shopify?.routes?.root
          ? window.Shopify.routes.root + "cart/update.js"
          : "/cart/update.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            attributes: {
              juicy_s2s: clickID
            }
          })
        }
      );

      if (!response.ok) {
        throw new Error("Cart update failed");
      }
    } catch (error) {
      console.warn("JuicyAds: cart update failed.");
    }
  }

  const clickID = getClickID();

  if (clickID) {
    attachClickIDToCart(clickID);
  }
})();